<template>
  <property-report-card
    title="5-Year Occupancy Forecast"
    description="Projected occupancy rates for this property are based on HelloData's dynamic forecasting model."
    :loading="isLoading"
    :printing-mode="printingMode"
  >
    <template #actions>
      <q-select
        v-model="frequency"
        :disable="isLoading"
        :options="frequencyOptions"
        dense
        emit-value
        label="Frequency"
        map-options
        outlined
        style="width: 150px"
        transition-duration="100"
        @update:model-value="
          (val) => $tracker.changedFilter('frequency', 'occupancy_projections', val)
        "
      />
    </template>
    <q-separator />
    <occupancy-projections-chart
      :is-single-property="true"
      :frequency="frequency"
      :subject-property="subjectProperty"
    >
      <template v-if="!subjectProperty" #empty-state>
        <div
          class="full-width full-height flex flex-center text-center text-primary"
          style="font-size: 12px"
        >
          No data found for Subject Property or missing Subject Property.
        </div>
      </template>
    </occupancy-projections-chart>
    <q-card-section class="q-gutter-y-sm">
      <div class="text-weight-bold">How Our Forecasts Work</div>
      <div style="font-size: 12px">
        HelloData's occupancy projections are generated using a deep-learning model designed
        specifically for multifamily markets.
      </div>
    </q-card-section>
  </property-report-card>
</template>

<script lang="ts">
import { type PropType, computed } from 'vue'
import type { PropertyDetailsResponse } from 'common'
import { useSinglePropertyRentProjection } from '@/queries/rentProjections.ts'
import PropertyReportCard from '@/components/PropertyReportCard.vue'
import OccupancyProjectionsChart from '@/components/Charts/OccupancyProjectionsChart.vue'
import type { ProjectionFrequency } from '@/utils'

export default {
  name: 'PropertyCompareOccupancyProjections',
  props: {
    subjectProperty: {
      type: Object as PropType<PropertyDetailsResponse | null>,
      default: null
    },
    printingMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PropertyReportCard,
    OccupancyProjectionsChart
  },
  data() {
    return {
      frequency: 'yearly' as ProjectionFrequency,
      frequencyOptions: [
        { label: 'Yearly', value: 'yearly' },
        { label: 'Quarterly', value: 'quarterly' },
        { label: 'Monthly', value: 'monthly' }
      ]
    }
  },
  setup(props) {
    const lat = computed(() => props.subjectProperty?.lat ?? null)
    const lng = computed(() => props.subjectProperty?.lon ?? null)
    const isLeaseUp = computed(() => props.subjectProperty?.is_lease_up ?? false)
    const { isLoading } = useSinglePropertyRentProjection(lat, lng, isLeaseUp)
    return { isLoading }
  }
}
</script>
